import { render, staticRenderFns } from "./PageContentImage.ts.vue?vue&type=template&id=84de52ae&"
import script from "./PageContentImage.ts.vue?vue&type=script&lang=ts&"
export * from "./PageContentImage.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports